import React, { useCallback, useState } from 'react'
import { Paragraph, Divider, InfoSheet, InputLabel, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import ZionForm, { useZionForm, FormTextField, useWatch } from '@fs/zion-form'
import { format } from '@fs/zion-locale/date-fns'
import { i18n } from '@fs/zion-locale'
import ContributorActionChips from './ContributorActionChips'

const todaysDateTimeNumber = Date.now()
const todaysDateDate = new Date(todaysDateTimeNumber)
const todaysDateIsoString = todaysDateDate.toISOString().split('T')[0]

export default function OptionsSideSheet({ infoSheetConfig, changeOptions, contributors }) {
  const todaysDateFormatted = format(todaysDateTimeNumber, 'PPP', { locale: i18n.language })
  const [t] = useTranslation()
  // This state is needed outside of the infoSheet since the InfoSheet does not retain state. It might in zion-ui v14/v15
  const [selectedContributorMap, setSelectedContributorMap] = useState({})

  const methods = useZionForm({
    mode: 'all',
    defaultValues: { filterDate: null },
  })

  const { filterDate } = useWatch({
    control: methods.control,
  })

  // NOTE backend has this mixed up currently. See TF-3601
  const onDateFilterChange = useCallback(
    (filterDateIsoStr) => {
      const zeroAmOfFilterDate = new Date(filterDateIsoStr || 0)
      const zeroAmOfFilterDateTimeNumber = zeroAmOfFilterDate.getTime()

      changeOptions({ timestamp: zeroAmOfFilterDateTimeNumber })
      return undefined
    },
    [changeOptions]
  )

  return (
    <InfoSheet title={t('group-management.options.action')} {...infoSheetConfig} size="md">
      {(infoSheetConfig.open || infoSheetConfig.transitioning) && (
        <>
          <Paragraph>{t('group-management.view-by.label')}</Paragraph>
          <Separator size="xxs" />

          {/* ZionForm needed for type=date */}
          <ZionForm data-testid="data-filter-form" methods={methods}>
            <FormTextField
              data-testid="date-filter"
              label={
                <Paragraph size="xs" as="strong">
                  {t('group-management.from.label')}
                </Paragraph>
              }
              type="date"
              max={todaysDateIsoString}
              onChange={(e) => onDateFilterChange(e.target.value)}
              onClear={() => changeOptions({ timestamp: undefined })}
              name="filterDate"
              clearable={filterDate}
            />
          </ZionForm>
          <InputLabel>
            <Paragraph size="xs" as="strong">
              {t('group-management.to.label')}
            </Paragraph>
          </InputLabel>
          <div />
          {todaysDateFormatted}

          {contributors && (
            <>
              <Divider marginY="sm" />
              <Paragraph>{t('group-management.filter-by-contributor.label')}</Paragraph>
              <Separator size="nano" />
              <ContributorActionChips
                contributors={contributors}
                changeOptions={changeOptions}
                selectedContributorMap={selectedContributorMap}
                setSelectedContributorMap={setSelectedContributorMap}
              />
            </>
          )}
        </>
      )}
    </InfoSheet>
  )
}
